import nookies from 'nookies';
import { NextPageContext } from 'next';

export const getCookie = (key?: string, ctx?: NextPageContext) =>
  key ? nookies.get(ctx)[key] : undefined;

export const setCookie = (
  key: string,
  value: string | number,
  ctx?: NextPageContext,
) => {
  nookies.set(ctx, key, value.toString(), {
    maxAge: 7 * 24 * 60 * 60, // 7 days
    path: '/',
  });
};

export const removeCookie = (key: string, ctx?: NextPageContext) => {
  nookies.destroy(ctx, key);
};
